import(/* webpackMode: "eager" */ "/Users/mac/development/web_projects/codigo/capstate/src/app/not-found.tsx");
